import tenantLogo from '../assets/images/openfleet-logo.png';
import pinSmallMap from '../assets/images/custom/openfleet/openfleet-pin-small.svg';
import pinBigMap from '../assets/images/custom/openfleet/openfleet-pin-big.svg';
import favicon from '../assets/images/custom/openfleet/favicon.png';

const lerat = {
  tenant: {
    name: 'Lerat',
    politique_de_confidentialite_url:
      'https://www.openfleet.com/politique-de-confidentialite/',
    assets: {
      favicon: favicon,
      logo: tenantLogo,
      pinSmallMap: pinSmallMap,
      pinBigMap: pinBigMap
    }
  },
  typography: {
    fontFamily: [
      'SofiaPro',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(',')
  },
  palette: {
    primary: {
      light: '#0080BF',
      main: '#0080BF',
      dark: '#0080BF'
    },
    secondary: {
      main: '#0080BF'
    },
    background: {
      default: '#ffffff'
    }
  }
};

export default lerat;
